export enum ChallengeQuestTypeEnum {
    None = 0,
    GuaranteedEarnings = 1,
    TimeBasedIncentives = 2
}
